<template>
    <section class="etapa-container">
        <div class="flex-container my-4 w-screen overflow-x-scroll overscroll-x-none scroll">
            <div class="flex items-center gap-2 w-full mt-8 mb-6">
                <div v-for="(componente, index) in componentesEtapa" :key="index"
                    class="min-w-max py-2 px-3 rounded-full"
                    :class="etapaAtual == componente.etapa ? 'bg-[#C7DEFF] border border-azul-info' : 'bg-cinza-desabilitado'">
                    <router-link :to="`/${identificador}/${localRealizacao}/${modulo}/etapa/${componente.etapa}`">
                        <div :id="componente.chave" :data-href="`#${componente.chave}`"
                            :data-selecionado="etapaAtual == componente.etapa" class="flex items-center gap-1">
                            <img class="w-4 h-4" :src="componente.icone" alt="">
                            <span>{{ componente.descricao }}</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ComponenteEtapaService from '@/services/componentes/ComponenteEtapaService';
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'Etapa',
    props: {
        dadosComponentes: {
            type: Array,
            required: true
        }
    },
    mounted() {
        ComponenteEtapaService.manipulaScrollEtapa()
    },
    setup(props) {
        return ComponenteEtapaService.setup(props)
    },
});
</script>


<style scoped>
.scroll {
    overflow: auto;
    scrollbar-width: none;
}

.scroll::-webkit-scrollbar {
    width: 0;
    overflow-y: hidden;
}

.etapa-container {
    @apply flex justify-between items-center h-4 my-6 text-center font-medium;
}
</style>